import {
  useGetProductList,
  useUpdateProductList,
} from 'api-hooks/product/list';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useDismiss from 'hooks/use-dismiss';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import ProductListForm from './components/form';

export type ProductListViewParams = {
  id: string;
};

export default function ProductListView(
  props: NavigationProps<NavigationRoutes.ProductsView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetProductList({
    id,
  });
  const { mutateAsync, error: errorMutate } = useUpdateProductList();

  const product = data?.data;

  const onDismiss = useDismiss('products', product?.id);

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <ProductListForm
            {...props}
            renderError={
              !!errorMutate &&
              !!errorMutate.message && (
                <>
                  <Notification
                    overrides={{
                      Body: {
                        style: { width: 'auto', wordBreak: 'break-all' },
                      },
                    }}
                    kind={KIND.negative}
                    closeable
                  >
                    {() => errorMutate.message}
                  </Notification>
                  <SeparatorVertical $margin={8} />
                </>
              )
            }
            product={product}
            onSubmit={async (input, form) => {
              const result = await mutateAsync({
                body: input,
                id: product!.id!,
              });

              onDismiss(result.data.id);

              notification.success({ message: result?.message });

              return result.data;
            }}
          />
        </>
      }
    />
  );
}
